import { render } from "./MovingArrow.vue?vue&type=template&id=12659b80"
import script from "./MovingArrow.vue?vue&type=script&lang=js"
export * from "./MovingArrow.vue?vue&type=script&lang=js"

import "./MovingArrow.vue?vue&type=style&index=0&id=12659b80&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__